import { useEffect, useState } from "react";

import { useLanguage } from "@/i18n/LanguageContext";
import {
  adminMarkEnded,
  adminMarkLive,
  adminUpdateSession,
  fetchSessions,
  type ConferenceSession,
} from "../api";
import { formatDateTime, pickLocalized } from "../format";
import { PageHeader } from "../shells/PageHeader";

export function AdminSessionsPage() {
  const { t, locale } = useLanguage();
  const [rows, setRows] = useState<ConferenceSession[]>([]);

  const reload = () => fetchSessions().then(setRows);
  useEffect(() => {
    reload().catch(() => setRows([]));
  }, []);

  return (
    <div>
      <PageHeader title={t.admin.sessions} lead={t.schedule.preliminary || undefined} backTo="/admin" />
      <div className="dn-grid">
        {rows.map((s) => (
          <div className="dn-card" key={s.id}>
            <h3>{pickLocalized(s, locale, "title_en", "title_ar")}</h3>
            <p className="dn-muted">
              {formatDateTime(s.starts_at, locale)} – {formatDateTime(s.ends_at, locale)}
            </p>
            <p>
              Status: <strong>{s.status}</strong> · provider: {s.stream_provider || "—"}
            </p>
            <div className="dn-cta-row">
              <button
                type="button"
                className="dn-btn dn-btn-primary"
                onClick={async () => {
                  await adminUpdateSession(s.id, {
                    stream_provider: "demo",
                    status: "live",
                  });
                  await adminMarkLive(s.id);
                  await reload();
                }}
              >
                {t.admin.markLive}
              </button>
              <button
                type="button"
                className="dn-btn dn-btn-ghost"
                onClick={async () => {
                  await adminMarkEnded(s.id);
                  await reload();
                }}
              >
                {t.admin.markEnded}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
